import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface ChangePasscodeDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  passcode: string;
  setPasscode: (value: string) => void;
  confirmPasscode: string;
  setConfirmPasscode: (value: string) => void;
}

const ChangePasscodeDialog: React.FC<ChangePasscodeDialogProps> = ({
  open,
  onClose,
  onSave,
  passcode,
  setPasscode,
  confirmPasscode,
  setConfirmPasscode
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Change Passcode</DialogTitle>
    <DialogContent>
      <TextField
        label="New Passcode"
        type="password"
        value={passcode}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPasscode(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Confirm Passcode"
        type="password"
        value={confirmPasscode}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPasscode(e.target.value)}
        fullWidth
        margin="normal"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSave} variant="contained">Save</Button>
    </DialogActions>
  </Dialog>
);

export default ChangePasscodeDialog; 